import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { get } from 'lodash';
import React from 'react';
import { Form, OriCheckbox, OriNumberInput } from 'src/components/Antd';
import { maxTimes } from 'src/tools/constant';
import { isInteger } from 'src/tools/helper';
import css from './css.module.less';
import { ECondition } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/CustomerEligibleCondition';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;
export enum EField {
  maxInTotal = 'maxInTotal',
  maxPerCustomer = 'maxPerCustomer',
  maxPerOrder = 'maxPerOrder',
}

const UsageLimitation = (props) => {
  const { fields, used, disableEdit } = props;
  const _used = used || 0;

  return (
    <div className={css.limitationContainer}>
      {fields.map((i) => {
        const field = get(i, 'field');
        const description = get(i, 'description');
        const checkboxName = get(i, 'checkboxName');
        const valueName = get(i, 'valueName');

        if (field === EField.maxInTotal) {
          return (
            <MaxInTotal
              key={field}
              used={_used}
              description={description}
              checkboxName={checkboxName}
              valueName={valueName}
              disableEdit={disableEdit}
            />
          );
        }
        if (field === EField.maxPerCustomer) {
          const disabledDependency = get(i, 'disabledDependency');
          return (
            <MaxPerCustomer
              key={field}
              checkboxName={checkboxName}
              valueName={valueName}
              description={description}
              disableEdit={disableEdit}
              disabledDependency={disabledDependency}
            />
          );
        }
        return null;
      })}
    </div>
  );
};
export default UsageLimitation;

const MaxInTotal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };

  const { used, description, checkboxName, valueName, disableEdit } = props;
  //   const checkboxName = ['userLimitation', 'maxInTotalEnabled'];
  //   const valueName = ['userLimitation', 'maxInTotal'];
  return (
    <React.Fragment>
      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, checkboxName);
          const cV = get(c, checkboxName);
          return cV !== pV;
        }}>
        {({ getFieldValue }) => {
          const isChecked = getFieldValue(checkboxName);
          const body = () => {
            if (isChecked) {
              return (
                <div className={css.usageContainer}>
                  <Item
                    className={css.numberItem}
                    name={valueName}
                    rules={[
                      {
                        validator: async (x, value) => {
                          if (!isInteger(value)) {
                            return Promise.reject(
                              new Error(
                                getI18n('general.pleasefillavalidvalue'),
                              ),
                            );
                          }
                          if (value < 1) {
                            return Promise.reject(
                              new Error(`${getI18n('general.noLessThan')} 1`),
                            );
                          }
                          if (used > value) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'salesChannelDirectDiscount.usage.greaterThanUsed',
                                ),
                              ),
                            );
                          }
                        },
                      },
                    ]}>
                    <OriNumberInput
                      min={0}
                      max={maxTimes}
                      size='large'
                      className={css.numberInput}
                      disabled={disableEdit}
                    />
                  </Item>
                  <div className={css.usedContainer}>
                    {getI18n('general.status.used')}: {used}
                  </div>
                </div>
              );
            }
            return null;
          };
          return (
            <ItemWrapper
              titleContainerClassName={
                isChecked ? '' : css.titleContainerClassName
              }
              title={
                <Item name={checkboxName} valuePropName='checked'>
                  <OriCheckbox className={css.checkbox} disabled={disableEdit}>
                    {description ||
                      getI18n('salesChannelDirectDiscount.usage.setMaxNumber')}
                  </OriCheckbox>
                </Item>
              }>
              {body()}
            </ItemWrapper>
          );
        }}
      </Item>
    </React.Fragment>
  );
};

const MaxPerCustomer = (props) => {
  const {
    description,
    checkboxName,
    valueName,
    disableEdit,
    disabledDependency,
  } = props;
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <React.Fragment>
      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, checkboxName);
          const cV = get(c, checkboxName);
          if (disabledDependency) {
            const pP = get(p, disabledDependency);
            const cP = get(c, disabledDependency);
            return cV !== pV || pP !== cP;
          } else {
            return cV !== pV;
          }
        }}>
        {({ getFieldValue }) => {
          const isEveryone = disabledDependency
            ? getFieldValue(disabledDependency) === ECondition.Everyone
            : false;

          // if (isEveryone) {
          // }
          const isChecked = getFieldValue(checkboxName);
          const body = () => {
            if (isChecked) {
              return (
                <div className={css.usageContainer}>
                  <Item
                    className={css.numberItem}
                    name={valueName}
                    rules={[
                      {
                        validator: async (x, value) => {
                          if (!isInteger(value)) {
                            return Promise.reject(
                              new Error(
                                getI18n('general.pleasefillavalidvalue'),
                              ),
                            );
                          }
                          if (value < 1) {
                            return Promise.reject(
                              new Error(`${getI18n('general.noLessThan')} 1`),
                            );
                          }
                        },
                      },
                    ]}>
                    <OriNumberInput
                      size='large'
                      className={css.numberInput}
                      min={0}
                      max={maxTimes}
                      disabled={disableEdit || isEveryone}
                    />
                  </Item>
                </div>
              );
            }
            return null;
          };
          return (
            <ItemWrapper
              titleContainerClassName={
                isChecked ? '' : css.titleContainerClassName
              }
              title={
                <Item name={checkboxName} valuePropName='checked'>
                  <OriCheckbox
                    className={css.checkbox}
                    disabled={disableEdit || isEveryone}>
                    {description ||
                      getI18n(
                        'salesChannelDirectDiscount.usage.setMaxNumberForCustomer',
                      )}
                  </OriCheckbox>
                </Item>
              }>
              {body()}
            </ItemWrapper>
          );
        }}
      </Item>
    </React.Fragment>
  );
};
